"use strict";
import { TrackableEnum } from "#src/util/trackable_enum.js";
export var VolumeRenderingModes = /* @__PURE__ */ ((VolumeRenderingModes2) => {
  VolumeRenderingModes2[VolumeRenderingModes2["OFF"] = 0] = "OFF";
  VolumeRenderingModes2[VolumeRenderingModes2["ON"] = 1] = "ON";
  VolumeRenderingModes2[VolumeRenderingModes2["MAX"] = 2] = "MAX";
  VolumeRenderingModes2[VolumeRenderingModes2["MIN"] = 3] = "MIN";
  return VolumeRenderingModes2;
})(VolumeRenderingModes || {});
export function trackableShaderModeValue(initialValue = 0 /* OFF */) {
  return new TrackableEnum(VolumeRenderingModes, initialValue);
}
export function isProjectionMode(mode) {
  return mode === 2 /* MAX */ || mode === 3 /* MIN */;
}
export function isProjectionLayer(layer) {
  return isProjectionMode(layer.mode.value);
}
